module.exports = __webpack_public_path__ + "img/pi-4-5.92df5f0d.jpg";